import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes, PreloadAllModules} from '@angular/router';
import {SsoAuthGuard} from './core/auth/guards/sso-auth-guard.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/appshell/app-shell.module').then(m => m.AppShellModule),
    canActivate: [SsoAuthGuard]
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AppRoutingModule {
}
